import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

type Props = {
  fallback?: string;
  label?: string;
  className?: string;
};

/**
 * Liten "Tillbaka"-knapp som fungerar både inom iframe (embed-läge) och
 * fristående. Använder browserns history när det går, annars en fallback-route.
 */
export function BackLink({ fallback = "/access", label = "Tillbaka", className = "" }: Props) {
  const navigate = useNavigate();

  function goBack() {
    // window.history.length är ≥ 1 även för en ny tabb; använd > 1 som heuristik
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className={
        "inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition rounded-full px-3 py-1.5 border border-border bg-white/60 hover:bg-white " +
        className
      }
      aria-label={label}
    >
      <ArrowLeft size={14} />
      <span className="font-display">{label}</span>
    </button>
  );
}
